export default {
  "workspace": {
    "rename_modal_dialog": {
      "title": "Rename {type} {name}",
      "name_input": "{type} new name",
      "submit_button": "Update"
    },
    "create_modal_dialog": {
      "title": "Create a new {type}.",
      "folder_name_input": "Workspace name",
      "submit_button": "Create workspace",
      "subtitle": "Name it and choose how it shows in the sidebar.",
      "name_placeholder": "Name your workspace",
      "usage": "{used} of {limit} workspaces"
    },
    "customize": {
      "title": "Customize workspace",
      "subtitle": "How this workspace is named and shown in the sidebar.",
      "name": "Name",
      "color": "Background color",
      "avatar": "Avatar",
      "initials": "Initials",
      "icon": "Icon",
      "emoji": "Emoji",
      "customColor": "Custom color",
      "save": "Save",
      "saved": "Workspace updated"
    },
    "menu": {
      "customize": "Customize",
      "settings": "Workspace settings",
      "label": "Workspace options"
    },
    "switcher": {
      "current": "Workspace {workspace} in {organization}"
    }
  }
};
